export class CertifFakeDb
{
    public static courses = [
        {
            'id'      : '1',
            'title'   : 'Certificar',
            'slug'    : 'cgo-certificar',
            'category': 'CGO',
            'length'  : 30,
            'updated' : '9 Agosto 2019'
        }
    ];

    public static categories = [
        {
            'id'   : 0,
            'value': 'CGO',
            'label': 'culturalgo'
        }
    ];

    private static demoSteps = [
        {
            'title'  : 'Paso 1',
            'content': '<h1>Paso 1 del proceso</h1>' +
            '<br>' +
            'Lorem ipsum dolor sit amet...',
            'icon' : 'pets'
        },
        {
            'title'  : 'Paso 2',
            'content': '<h1>Paso 2 del proceso</h1>' +
            '<br>' +
            'Lorem ipsum dolor sit amet...',
            'icon' : 'polymer'
        },
        {
            'title'  : 'Paso 3',
            'content': '<h1>Paso 3 del proceso</h1>' +
            '<br>' +
            'Lorem ipsum dolor sit amet...',
            'icon' : 'stars'
        },
        {
            'title'  : 'Paso 4',
            'content': '<h1>Paso 4 del proceso</h1>' +
            '<br>' +
            'Lorem ipsum dolor sit amet...',
            'icon' : 'sentiment_satisfied_alt'
        }
    ];

    public static course = [
        {
            'id'         : '1',
            'title'      : 'Certificar',
            'slug'       : 'cgo-certificar',
            'description': 'Commits that need to be pushed lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'category'   : 'CGO',
            'length'     : 30,
            'totalSteps' : 5,
            'updated'    : '9 Agosto 2019',
            'steps'      : CertifFakeDb.demoSteps
        }
    ];

}
